import { useContext } from 'react'

import { ReportBudgetContext } from '@provider/Budget/ReportProvider'

import type { IBudgetReportContext } from '@base/@types/providers/Budget/Report'

export default function useReportBudget(): IBudgetReportContext {
  const context = useContext(ReportBudgetContext)

  return context
}
